import React, { useEffect } from "react";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Tooltip } from "antd";
import { ButtonProps } from "antd/lib/button/Button";
import {
  ReadingTableRow,
  useReadingsDelete,
} from "../../../../../../hooks/api/readings";
import { listAction } from "../../../../../Common/Table";
import {
  useMessageError,
  useMessageSuccess,
} from "../../../../../../hooks/common";
import { useSimpleModal } from "../../../../../Common/Modal/Simple";

interface DeleteReadingButtonProps {
  record: ReadingTableRow;
  setTableKey?: (newVal: number) => void;
  afterSuccess?: () => void;
  buttonProps?: ButtonProps;
}

export default function DeleteReadingButton({
  record,
  setTableKey,
  afterSuccess,
  buttonProps,
}: DeleteReadingButtonProps) {
  const readingDelete = useReadingsDelete(`${record.id}/vaad`);
  const { open, contextHolder } = useSimpleModal();

  useMessageError([readingDelete]);
  useMessageSuccess([readingDelete], "Reading has been removed successfully");

  useEffect(() => {
    if (!readingDelete.error && !readingDelete.loading && readingDelete.data) {
      setTableKey?.(Date.now());
      afterSuccess?.();
    }
  }, [
    readingDelete.error,
    readingDelete.loading,
    readingDelete.data,
    setTableKey,
    afterSuccess,
  ]);

  const ActionButton = listAction.delete;

  return (
    <>
      <Tooltip title="Delete reading" placement="topRight">
        <ActionButton
          loading={readingDelete.loading}
          title="Delete reading?"
          onClick={(e: React.MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();
            open({
              icon: <ExclamationCircleFilled />,
              title: "Remove reading from Vaad?",
              content: (
                <span>
                  This will not delete the file from the master library, but it
                  will be removed from the associated meeting and Vaad Library.
                </span>
              ),
              cancelText: "Cancel",
              okText: "Delete",
              okButtonProps: { danger: true },
              onOk: () =>
                readingDelete.fetch().then(() => setTableKey?.(Date.now())),
            });
          }}
          {...buttonProps}
        />
      </Tooltip>
      {contextHolder}
    </>
  );
}
